export const REPORT_REQUEST = 'REPORT_REQUEST/SALES-CHALLENGE';
export const REPORT_SUCCESS = 'REPORT_SUCCESS/SALES-CHALLENGE';
export const REPORT_FAIL = 'REPORT_FAIL/SALES-CHALLENGE';

export function reportRequest(payload) {
  return {
    type: REPORT_REQUEST,
    payload,
  };
}

export function reportSuccess(payload) {
  return {
    type: REPORT_SUCCESS,
    payload,
  };
}

export function reportFail(payload) {
  return {
    type: REPORT_FAIL,
    payload,
  };
}
